import { formTypes } from "../../form/form.constants";
import { ProjectForm } from "../../project/models/form.model";
import { BusinessInformation } from "./business-information.model";
import { ResearchAndDevelopmentInformation } from "./research-and-development-information.model";
import { IncreaseInRdCalculation } from "./increase-in-rd-calculation.model";
import { ManagerTaxCreditCalculation } from "./manager-tax-credit-calculation.model";
import { CreditIssuance } from "./credit-issuance.model";
import { RdFormType } from "./rd-form-type";


export class RDIncreaseinRDApplication extends ProjectForm {
  get qualifier(): string {
      return null;
  }

  type: RdFormType;
  // business information
  businessInformation: BusinessInformation;
  researchAndDevelopmentInformation: ResearchAndDevelopmentInformation;
  taxCreditCalculation: IncreaseInRdCalculation;
  managerTaxCreditCalculation: ManagerTaxCreditCalculation;
  creditIssuance: CreditIssuance;

  constructor(rdApplication?: any) {
      super();
  }

  init(): RDIncreaseinRDApplication {
    super.init();
    this.type = <RdFormType>formTypes.rdIncreaseInRD.abbrev;
    this.businessInformation = this.businessInformation || new BusinessInformation();
    this.researchAndDevelopmentInformation =
      this.researchAndDevelopmentInformation || new ResearchAndDevelopmentInformation();
    this.taxCreditCalculation = this.taxCreditCalculation || new IncreaseInRdCalculation();
    this.managerTaxCreditCalculation =
      this.managerTaxCreditCalculation || new ManagerTaxCreditCalculation();
    this.creditIssuance = this.creditIssuance || new CreditIssuance();
    return this;
  }

}
